import {
  ASYNC_ERROR,
  ASYNC_FINISH,
  ASYNC_START,
  CLEAR_STATE,
  INITIALIZE,
  IUiState,
  UiActionTypes,
} from './types'

export const initialState: IUiState = {
  initialized: false,
  loading: false,
  error: '',
  message: 'NONE',
}

const uiReducer = (state = initialState, action: UiActionTypes): IUiState => {
  switch (action.type) {
    case INITIALIZE:
      return {
        loading: false,
        error: '',
        initialized: true,
        message: 'INITIALIZED',
      }
    case ASYNC_START:
      return {
        initialized: true,
        loading: true,
        error: '',
        message: action.message || 'INITIALIZED',
      }

    case ASYNC_FINISH:
      return {
        initialized: true,
        loading: false,
        error: '',
        message: action.message || 'INITIALIZED',
      }

    case ASYNC_ERROR:
      return {
        initialized: true,
        error: action.error,
        loading: false,
        message: 'ERROR',
      }

    case CLEAR_STATE:
      return {
        initialized: true,
        error: '',
        loading: false,
        message: 'INITIALIZED',
      }

    default:
      return state
  }
}

export default uiReducer
